import React from 'react';
import FileSaveAs from '../downloaders/FileSaveAs';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import SaveFilingToWorkflow from './SaveFilingToWorkflow';
import ApplicationMessagesWrapper from '../inAppMessages/ApplicationMessagesWrapper';
import { ALL_MESSAGES } from '../../utils/logger';
import { RETURN_APPROVAL_WARNING_MESSAGES } from '../../utils/returnApprovalConfig';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const noOp = () => { };

const ReturnGenerationControls = (props) => {

    const {
        onSubmitClick = noOp, onRegenerateClick = noOp,
        showSubmit = false, showRegenerate = false, showDownload = false,
        showPdfPreviewWorkflow = false, showPdfPreviewDownload = false,
        showWorkflow = false, onSaveToWorkflow = noOp,
        filename = "", onDownloadPdfPreviewClick = noOp,
        submitOptions = {},
        fileExtension = '.xml',
        MarkAsSubmittedButton = null,
        CountrySpecificSubmitButton = null,
        ApprovalControls = null,
        onInitiateAutoSubmission = noOp, onGoToTaskList = noOp,
        showInitiateAutoSubmission = false, showDirectSubmissionStatus = false,
        canInitiateAutoSubmission = false, initiateDisabledTooltip = '',
        showApprovalWarning = false,
        disableRegenerate = false, regenerateDisabledTooltip = '',
        disableMarkAsSubmitted = false, markAsSubmittedDisabledTooltip = ''
    } = props;
    const SubmitButton = showSubmit ? (
        <FileSaveAs downloadLabel={(<LanguageStringResolver string='filingPage_ApproveAndDownloadBtn' />)}
            className={submitOptions.buttonClass || 'primary ml10'}
            fetchContent={() => onSubmitClick(false)}
            content={submitOptions.content}
            filename={filename}
            mimeType={submitOptions.mimeType}
            charset={submitOptions.charset}
            isBlob={submitOptions.isBlob}
            onClick
        />
    ) : (<></>);

    const RegenerateButton = showRegenerate ? (
        <button
            className="secondary"
            onClick={onRegenerateClick}
            excludeFromReadonly={true}
            disabled={disableRegenerate}
            title={disableRegenerate ? regenerateDisabledTooltip : undefined}
            data-testid="regenerate-btn"
        >
            <LanguageStringResolver string='filingPage_Regenerate' />
        </button>
    ) : (<></>);

    const MarkAsSubmittedButtonElement = MarkAsSubmittedButton && disableMarkAsSubmitted
        ? React.cloneElement(MarkAsSubmittedButton, {
            disabled: true,
            title: markAsSubmittedDisabledTooltip,
        })
        : MarkAsSubmittedButton;

    const DownloadButton = showDownload ? (
        <FileSaveAs downloadLabel={(<span><LanguageStringResolver string='filingPage_DownloadBtn' /> {filename}{fileExtension}</span>)}
            className={submitOptions.buttonClass || 'secondary ml10'}
            fetchContent={() => onSubmitClick(true)}
            content={submitOptions.content}
            filename={filename}
            mimeType={submitOptions.mimeType}
            charset={submitOptions.charset}
            isBlob={submitOptions.isBlob}
            onClick
            excludeFromReadonly={true}
        />
    ) : (<></>);

    const SaveToWorkflowButton = showWorkflow ? (
        <SaveFilingToWorkflow onSaveToWorkflow={onSaveToWorkflow} />
    ) : (<></>);

    const DownloadPdfPreviewButton = showPdfPreviewDownload ? (
        <FileSaveAs downloadLabel={(<span><LanguageStringResolver string='filingPage_DownloadPdfPreview' /></span>)}
        className={submitOptions.buttonClass || 'secondary ml10'}
        fetchContent={() => onDownloadPdfPreviewClick()}
        content={submitOptions.content}
        filename={`${filename}_PREVIEW`}
        mimeType="application/pdf"
        charset={submitOptions.charset}
        isBlob={submitOptions.isBlob}
        onClick
        excludeFromReadonly={true}
    />
    ) : (<></>);

    const SavePdfPreviewToWorkflowButton = showPdfPreviewWorkflow ? (
        <SaveFilingToWorkflow onSaveToWorkflow={onSaveToWorkflow} isFileVatBookPreviewPdf={true}/>
    ) : (<></>);

    const InitiateAutoSubmissionButton = showInitiateAutoSubmission ? (
        <ReadOnlyWrapper>
            <button
                className="secondary ml10"
                onClick={onInitiateAutoSubmission}
                disabled={!canInitiateAutoSubmission}
                title={canInitiateAutoSubmission ? undefined : initiateDisabledTooltip}
                data-testid="initiate-direct-submission-btn"
            >
                <LanguageStringResolver string='filingPage_InitiateDirectSubmissionBtn' />
            </button>
        </ReadOnlyWrapper>
    ) : (<></>);

    // Viewing direct submission task/status is not a gated capability - the only Direct
    // Submission grants are Initiate and Approve - so this button stays enabled for
    // read-only users, who can already reach the same page from the Compliance nav menu.
    const DirectSubmissionStatusButton = showDirectSubmissionStatus ? (
        <button
            className="secondary ml10"
            onClick={onGoToTaskList}
            excludeFromReadonly={true}
            data-testid="direct-submission-status-btn"
        >
            <LanguageStringResolver string='filingPage_DirectSubmissionStatusBtn' />
        </button>
    ) : (<></>);

    return (
        <div className="bottom-nav-panel-sticky">
            <div className="bottom-nav-panel">
                <ApplicationMessagesWrapper messageType="applicationSuccess" messageIds={[ALL_MESSAGES.SAVED_TO_WORKFLOW, ALL_MESSAGES.INITIATED_AUTO_SUBMISSION, ALL_MESSAGES.RETURN_APPROVAL_SENT]} />
                <ApplicationMessagesWrapper messageType="applicationError" messageIds={[ALL_MESSAGES.FAILED_TO_SAVE_TO_WORKFLOW, ALL_MESSAGES.AUTO_SUBMISSION_INITIATION_FAILED, ALL_MESSAGES.RETURN_APPROVAL_SEND_FAILED]} />
                <ApplicationMessagesWrapper messageType="applicationWarning" messageIds={RETURN_APPROVAL_WARNING_MESSAGES} />
                <ReadOnlyWrapper>
                  <div>
                      {RegenerateButton}
                      {DownloadButton}
                      {DownloadPdfPreviewButton}
                      {SaveToWorkflowButton}
                      {SavePdfPreviewToWorkflowButton}
                      {InitiateAutoSubmissionButton}
                      {DirectSubmissionStatusButton}
                      {ApprovalControls}
                      {SubmitButton}
                      {CountrySpecificSubmitButton || MarkAsSubmittedButtonElement}
                  </div>
                </ReadOnlyWrapper>
                {showApprovalWarning && <div data-testid="approval-warning"><LanguageStringResolver string='filingPage_ApproveAndDownloadBtn_FileRenameWarning' /></div>}
            </div>
        </div>
    )
}

export default ReturnGenerationControls